import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';

export const baseNumberTimeValidator = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const numberTimeSchema = new RegExp('^[0-9]{1,3}h?$');
    if (control.value && !numberTimeSchema.test(control.value)) {
      return { numberTime: true };
    }
    return null;
  };
};
